export function getCurrencySymbol(
    currency: string = "USD",
    locale: string = "fr-FR",
): string {
    const parts = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
    }).formatToParts(0);

    let symbol =
        parts.find((part) => part.type === "currency")?.value ?? currency;

    // Harmonisation avec ton formatCurrency
    if (locale.startsWith("fr") && currency.toUpperCase() === "USD") {
        symbol = symbol.replace("$US", "$");
    }

    return symbol;
}